import "./index.es44.js";
import i from "./index.es45.js";
import "./index.es46.js";
import "./index.es47.js";
import "./index.es48.js";
import "./index.es49.js";
import m from "react";
import "./index.es50.js";
import "./index.es51.js";
import l from "./index.es76.js";
const k = ({
  data: t,
  sheets: o,
  fileName: r
}) => {
  const e = () => {
    l(t, { sheets: o, fileName: r });
  };
  return /* @__PURE__ */ m.createElement(i, { isSmall: !0, styleType: "primary", onClick: e }, "Last ned data");
};
export {
  k as default
};
//# sourceMappingURL=index.es57.js.map
